import { z } from "zod";

// Strong password validation
export const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .max(128, "Password is too long")
  .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
  .regex(/[a-z]/, "Password must contain at least one lowercase letter")
  .regex(/[0-9]/, "Password must contain at least one number")
  .regex(/[^A-Za-z0-9]/, "Password must contain at least one special character");

// Email validation
export const emailSchema = z
  .string()
  .trim()
  .email("Invalid email address")
  .max(255, "Email is too long")
  .toLowerCase();

// Name validation - only letters, spaces, hyphens, apostrophes
const nameRegex = /^[a-zA-Z\s\-']+$/;

export const nameSchema = z
  .string()
  .trim()
  .min(1, "Name is required")
  .max(50, "Name is too long")
  .regex(nameRegex, "Name can only contain letters, spaces, hyphens, and apostrophes");

// Ambassador message validation
export const ambassadorMessageSchema = z
  .string()
  .trim()
  .max(1000, "Message is too long")
  .optional();

// Complete sign-up schema
export const signUpSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  firstName: nameSchema,
  lastName: nameSchema,
  userType: z.enum(["user", "ambassador"]),
  ambassadorMessage: ambassadorMessageSchema
});

// Sign-in schema (simpler validation for login)
export const signInSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, "Password is required")
});

// Type exports for use in components
export type SignUpData = z.infer<typeof signUpSchema>;
export type SignInData = z.infer<typeof signInSchema>;
